import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getMainPageAPI from '../../api/get-main-page';
import { IMainPage } from '../../utils/types/state-types';
import { receiveMainPage, rejectMainPage, requestMainPage } from '../actions/main-page';

const getMainPage = function* getMainPage() {
  try {
    const response: IMainPage = yield call(getMainPageAPI);
    yield put(receiveMainPage({ mainPage: response }));
  } catch (error) {
    yield put(rejectMainPage({ error }));
  }
};

export default function* getMainPageWatcher() {
  yield takeLatest(requestMainPage, getMainPage);
}
